import axiosAuth from '../../axiosMain';
import vueStore from '@/store';

async function store(data) {
  let response = await axiosAuth.post('/answers', data);
  return response.data;
}

async function destroy(id) {
  let response = await axiosAuth.delete('/answers/' + id);
  return response.data;
}

export default {
  store,
  destroy,
};
